import { render, staticRenderFns } from "./HomeWaitPartners.vue?vue&type=template&id=167315fb&scoped=true&"
import script from "./HomeWaitPartners.vue?vue&type=script&lang=js&"
export * from "./HomeWaitPartners.vue?vue&type=script&lang=js&"
import style0 from "./HomeWaitPartners.vue?vue&type=style&index=0&id=167315fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167315fb",
  null
  
)

export default component.exports